import { render } from "./CourseGroupDetail.vue?vue&type=template&id=31f1c7d4&scoped=true"
import script from "./CourseGroupDetail.vue?vue&type=script&lang=js"
export * from "./CourseGroupDetail.vue?vue&type=script&lang=js"

import "./CourseGroupDetail.vue?vue&type=style&index=0&id=31f1c7d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f1c7d4"]])

export default __exports__